import { useQuery } from '@tanstack/react-query';
import { cliengoQueries, getLDClient, initLaunchDarkly } from '@cliengo/mfe-utils/mod';
import { WHATSAPP_CLOUD_FLAG } from '@/constants/whatsapp-cloud';

/**
 * Evalúa `feature.2097.whatsapp-cloud-onboarding` con el usuario logueado.
 * Mientras carga o si LD falla, el flag cuenta como apagado (flujo Coexistence).
 */
export const useWhatsAppCloudFlag = (enabled: boolean) => {
  const { data: user, status: userStatus } = cliengoQueries.user();
  const { data: account, status: accountStatus } = cliengoQueries.account();

  const { data: isOn, isLoading } = useQuery({
    queryKey: ['ld-flag', WHATSAPP_CLOUD_FLAG, user?.id, account?.id],
    queryFn: async () => {
      await initLaunchDarkly(user!, account!);
      return getLDClient().variation(WHATSAPP_CLOUD_FLAG, false) === true;
    },
    enabled: enabled && !!user && !!account,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return {
    isOn: isOn === true,
    // Si user/account fallan la query queda deshabilitada: no carga, flag apagado.
    isLoading: enabled && (userStatus === 'pending' || accountStatus === 'pending' || isLoading),
  };
};
